import { useFragment } from 'react-relay';
import { Link } from 'react-router-dom';
import { breadcrumbFragment } from './Breadcrumb.relay';
import type { BreadcrumbPropsType } from './types';

function Breadcrumb(props: BreadcrumbPropsType) {
  const data = useFragment(breadcrumbFragment, props.data as any) as Array<{ label: string; link: string }> | null;

  return (
    <ul className="breadcrumb pt-3 pb-[75px] my-0 mx-auto max-[1100px]:max-w-[565px] px-0 max-[600px]:px-4">
      {data.map((breadcrumb) => (
        <li
          key={breadcrumb.label}
          className="inline list-none uppercase text-black text-xs tracking-[1px] after:content-['»'] after:inline-block after:text-accent after:mx-[0.25em] after:text-[1.1em] last:after:content-none"
        >
          {breadcrumb.link && breadcrumb.link.length > 0 ? (
            <Link to={breadcrumb.link} className="uppercase text-black no-underline hover:text-accent">
              {breadcrumb.label}
            </Link>
          ) : (
            breadcrumb.label
          )}
        </li>
      ))}
    </ul>
  );
}

export { Breadcrumb };
